import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import enRaw from './locales/en.json?raw'
import koRaw from './locales/ko.json?raw'
import jaRaw from './locales/ja.json?raw'
import zhRaw from './locales/zh.json?raw'
import esRaw from './locales/es.json?raw'
import frRaw from './locales/fr.json?raw'
import deRaw from './locales/de.json?raw'

const stripBom = (value: string) => {
  let result = value
  while (result.length > 0 && result.charCodeAt(0) === 0xfeff) {
    result = result.slice(1)
  }
  return result
}
const parseLocaleJson = (raw: string) => JSON.parse(stripBom(raw)) as Record<string, unknown>

const en = parseLocaleJson(enRaw)
const ko = parseLocaleJson(koRaw)
const ja = parseLocaleJson(jaRaw)
const zh = parseLocaleJson(zhRaw)
const es = parseLocaleJson(esRaw)
const fr = parseLocaleJson(frRaw)
const de = parseLocaleJson(deRaw)

const resources = {
  en: { translation: en },
  ko: { translation: ko },
  ja: { translation: ja },
  zh: { translation: zh },
  es: { translation: es },
  fr: { translation: fr },
  de: { translation: de },
}

export const supportedLanguages = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'ko', name: 'Korean', nativeName: '한국어' },
  { code: 'ja', name: 'Japanese', nativeName: '日本語' },
  { code: 'zh', name: 'Chinese', nativeName: '中文' },
  { code: 'es', name: 'Spanish', nativeName: 'Español' },
  { code: 'fr', name: 'French', nativeName: 'Français' },
  { code: 'de', name: 'German', nativeName: 'Deutsch' },
]

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    lng: localStorage.getItem('language') || 'en',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  })

export default i18n
